<template>
  <div>
    <div class="right">
      <div class="searchbox">
        <form
          action="#"
          method="get"
          class="form-inline form-float"
          @submit.prevent
        >
          <div class="form-group">
            <label for>道路:</label>
            <search-parking></search-parking>
          </div>
          <div class="form-group">
            <label for>锁编号</label>
            <el-input v-model="search.devSn" placeholder="锁编号"></el-input>
          </div>
          <div class="form-group">
            <label for>泊位号</label>
            <el-input v-model="search.attr4" placeholder="泊位号"></el-input>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button
               size="small"
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
                :loading="loading"
              >
                查询
              </el-button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="addarea"
                @click="addOrEdit()"
              >
                添加
              </button>
            </span>
            <span class="operate-btn">
              <button
                type="button"
                class="btn btn-default"
                @click="executeBatchDel"
              >
                批量删除
              </button>
            </span>
            <span class="operate-btn">
              <button
                type="button"
                class="btn btn-default"
                @click="batchImport"
              >
                批量导入
              </button>
            </span>
            <span class="operate-btn">
              <button
                type="button"
                class="btn btn-default"
                @click="batchImport"
              >
                重启
              </button>
            </span>
            <span class="operate-btn">
              <button
                type="button"
                class="btn btn-default"
                @click="batchImport"
              >
                升锁
              </button>
            </span>
            <span class="batchImport_btn">
              <button
                type="button"
                class="btn btn-default"
                @click="batchImport"
              >
                降锁
              </button>
            </span>
            <span class="tableListDataAllNew_btn" style="margin-left: 4px">
              <button
                @click="downloadData"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                导出
              </button>
            </span>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          @selection-change="checkedList"
          v-loading="loading"
        >
          >
          <el-table-column
            show-overflow-tooltip
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="道路"
            prop="parkingName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="锁记录号"
            prop="parkingName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="泊位号"
            prop="devSn"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="网关编号"
            prop="attr1"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="设备版本"
            prop="company"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="设备编号"
            prop="attr4"
          ></el-table-column>

          <el-table-column show-overflow-tooltip label="设备状态">
            <template slot-scope="scope">
              <span>{{ scope.row.hasCar == "1" ? "有车" : "无车" }}</span>
            </template>
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="最后通讯时间"
            prop="attr3"
          ></el-table-column>
          <el-table-column
            width="200"
            show-overflow-tooltip
            label="信号强度"
            prop="lastUpTime"
          ></el-table-column>
          <el-table-column
            width="200"
            show-overflow-tooltip
            label="电量"
            prop="updTime"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="车位状态" prop="pow">
          </el-table-column>
          <el-table-column label="升锁设置" prop="network"></el-table-column>
          <el-table-column label="心跳时间" prop="snr"></el-table-column>
          <el-table-column label="告警" prop="seq"></el-table-column>
          <el-table-column label="异常" prop="attr5"></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="200px">
            <template slot-scope="scope">
              <button
                class="edit"
                type="button"
                @click="addOrEdit(scope.row.id)"
              >
                修改
              </button>
              <button class="delete" @click="del(scope.row.id)" type="button">
                删除
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
  <script>
import { mapState, mapMutations, mapGetters } from "vuex";
import {
  batchDelNbGeomagnetism,
  nbList,
  editNb,
  getAllEquipList,
  getAllParkingsByEnabled,
  fetchParkigList,
  requestNbType,
} from "@/api/url";
import Page from "../../commons/page.vue";
import ExportExcel from "../../commons/exportExcel.vue";
import Refresh from "../../commons/refresh.vue";
import AreaTree from "../../commons/areaTree.vue";
import SearchParking from "@/page/commons/searchParking";
export default {
  data() {
    return {
      dialogFormVisible: false,
      devManger_btn_edit: false,
      devManger_btn_remove: false,
      devManger_btn_add: false,
      batchImportResultDialogFormVisible: false,
      batchImportDialogFormVisible: false,
      cardShow: false,
      companyShow: true,

      moduleName: "",
      isChecked: true,
      park: "",

      styleObj: {
        "text-align": "center",
      },

      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      tableListParkDataAll: {},
      tableListAreaDataAll: {},
      allStations: {},
      parkingList: [],
      nbTypeList: [],
      editOrAddForm: {
        id: null,
        devSn: null,
        parkingId: null,
        uniqueAddress: null,
        company: null,
        attr4: null,
        type: null,
      },
      devStatus: [
        { name: "正常", value: "normal" },
        { name: "异常", value: "error" },
      ],
      editOrAddFormRules: {
        devSn: [{ required: true, message: "请填写地磁编号", trigger: "blur" }],
        parkingId: [
          {
            required: true,
            message: "请选择停车道路",
            trigger: ["blur", "change"],
          },
        ],
      },
      formLabelWidth: "100px",
      allOrderType: [],
      moduleName: "",
      temp: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        devStatu: "",
        devSn: "",
        attr4: "",
      },

      tableListData: {
        rows: [],
      },
      tableListDataAll: {},
      loading: false,
    };
  },
  filters: {
    status(value) {
      var resultValue = "";
      switch (value) {
        case "error":
          resultValue = "异常";
          break;
        case "异常":
          resultValue = "异常";
          break;
        case "normal":
          resultValue = "正常";
          break;
        case "正常":
          resultValue = "正常";
          break;
        default:
          break;
      }
      return resultValue;
    },
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList: function (curPage) {
      var _this = this;
      this.loading = true;
      //合并NB地磁借口
      const { devSn, attr4, pageSize } = this.search;
      this.$get(nbList(), {
        devSn: devSn ? devSn : null,
        attr4: attr4 ? attr4 : null,
        // spaceNum:'',
        parkingId: this.parking?.parkingId ?? null,
        limit: pageSize,
        page: curPage,
      })
        .then((data) => {
          if (data.status != 200) return;
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);
          const {
            data: { rows },
          } = data;
          _this.tableListData.rows = rows.map((item) => {
            if (
              item.parkingId &&
              typeof JSON.parse(item.parkingId) === "object"
            ) {
              item.parkingName = JSON.parse(item.parkingId).parkingName;
            }
            if (item.attr5 === "null") item.attr5 = "";
            return item;
          });
          _this.$nextTick(this.canvasPow);
          _this.$nextTick(() => {
            _this.$refs.table.doLayout();
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    tableListAll: function () {
      var _this = this;
      this.$get(getAllEquipList()).then((data) => {
        //if(data.status!=200) return _this.$layer.msg(data.message);
        this.tableListDataAll = data.data;
      });
    },
    tableListParkAll: function () {
      this.$get(getAllParkingsByEnabled()).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        var rows = data.data.rows;
        for (var i in rows) {
        }
        //console.log("tableListDataAll")
        //console.log(this.tableListData.rows)
        this.tableListParkDataAll = data.data;
      });
    },

    async addOrEdit(id) {
      this.dialogFormVisible = true;
      // this.editOrAddForm.company = "bosk";
      this.companyShow = false;
      await this.getParkingList();
      await this.getNbTypeList();
      if (!id) {
        this.editOrAddForm = {
          parkingId: null,
          devSn: null,
          attr4: null,
          company: "",
        };

        // if (!this.treeData.parkingId) {
        //   this.$message({
        //     type: "warning",
        //     message: "请选择道路",
        //   });
        //   this.dialogFormVisible = false;
        //   this.companyShow = true;
        //   this.cardShow = false;
        //   return;
        // }
      } else {
        this.$get(editNb() + "/" + id).then((data) => {
          if (data.status != 200) return;
          // this.companyShow = false;
          const {
            data: { devSn, attr4, attr2, company, id, parkingId },
          } = data;
          this.editOrAddForm = {
            id,
            devSn,
            attr4,
            attr2,
            parkingId,
            company,
          };

          // if (company === "zhonglian") {
          //   this.cardShow = false;
          // } else {
          //   this.cardShow = true;
          // }
        });
      }
    },
    addOrEditTrue() {
      var _this = this;
      this.$refs.editOrAddForm.validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          if (!_this.editOrAddForm.id) {
            _this
              .$postRequest(editNb(), {
                devSn: _this.editOrAddForm.devSn,
                parkingId: _this.editOrAddForm.parkingId,
                attr4: _this.editOrAddForm.attr4,
                company: _this.editOrAddForm.company,
                // company: "bosk",
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                if (data.status == 200) {
                  _this.$notify({
                    type: "success",
                    message: "添加成功！",
                    title: "成功",
                  });
                  _this.search.pageNumber = 1;
                  _this.tableList(_this.search.pageNumber);
                }
              });
          } else {
            _this
              .$putRequest(editNb() + "/" + _this.editOrAddForm.id, {
                devSn: _this.editOrAddForm.devSn,
                id: _this.editOrAddForm.id,
                parkingId: _this.editOrAddForm.parkingId,
                attr4: _this.editOrAddForm.attr4,
                company: _this.editOrAddForm.company,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);

                _this.$notify({
                  type: "success",
                  message: "修改成功！",
                  title: "成功",
                });
                _this.tableList(_this.pageObj.curIndex);
              });
          }
        }
      });
    },
    closeDialog: function () {
      this.$refs.editOrAddForm.resetFields();
    },
    del: function (id) {
      var _this = this;
      // console.log(id)
      var index = _this.$layer.confirm(
        "您确定删除该设备吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          // console.log("222")
          _this.$deleteRequest(editNb() + "/" + id, {}).then((data) => {
            if (data.status == 200) {
              _this.$notify({
                type: "success",
                message: "删除成功！",
                title: "成功",
              });
              _this.tableList(_this.pageObj.curIndex);
            }
            if (data.status == 30101) {
              _this.$notify.error({
                message:
                  "设备已绑定车位信息，不允许删除！如需删除，请先解绑设备和车位！",
                title: "失败",
              });
            }
          });
        }
      );
    },
    searchList() {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },

    downloadData() {
      const { devSn, attr4 } = this.search;
      // this.$downloadFileRequest(
      //   "/api/parking/nbOnerankdev/exportNbOnerankdev",
      //   {
      //    devSn: devSn ? devSn : null,
      //   attr4: attr4 ? attr4 : null,
      //   parkingId: this.parking?.parkingId ?? null,
      //   },
      //   "nb地磁"
      // );
    },

    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.type = "";
      this.search.startTime = "";
      this.search.endTime = "";
      this.search.devNum = "";
    },
    //  导出数据

    batchImport() {
      this.batchImportDialogFormVisible = true;
      // this.$refs.upload.clearFiles();
    },
    //批量上传
    submitUpload() {
      this.batchImportDialogFormVisible = false;
      // this.treeData.parkingId='';
      // this.treeData.areaId='';
      // this.$refs.areaTree.setCurrent('001');
      this.$refs.upload.submit();
      // this.search.pageNumber=1;
      // this.tableList(this.search.pageNumber);
    },
    bulkLoadTemplate() {
      window.open("api/parking/nbOnerankdev/importTemplate/", "_self");
    },
    fileSuccess(response, file, fileList) {
      var _this = this;
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
      this.batchImportResultDialogFormVisible = true;
      let span = document.createElement("span");
      this.$nextTick(function () {
        _this.$refs.showBatchImportResult.innerHTML = "";
        span.innerHTML = response.data;
        _this.$refs.showBatchImportResult.appendChild(span);
      });
    },
    fileError(err, file, fileList) {
      // console.log(err)
    },
    closeUpload() {
      this.$refs.upload.clearFiles();
    },
    checkedList(val) {
      this.batchDel = val.map((item) => {
        return item.id;
      });
    },
    executeBatchDel() {
      this.$postRequest(batchDelNbGeomagnetism(), {
        ids: this.batchDel,
      }).then((data) => {
        if (data.status == 200) {
          this.$notify({
            type: "success",
            message: "批量删除成功！",
            title: "成功",
          });
          this.tableList(this.pageObj.curIndex);
          this.batchDel = [];
          // if (this.$refs.checkBoxAll.checked) {
          //   this.$refs.checkBoxAll.checked = false;
          // }
        }
      });
    },
    getParkingList() {
      return this.$get(fetchParkigList()).then((res) => {
        const { status, data } = res;
        if (status === 200) {
          this.parkingList = data;
        }
      });
    },
    getNbTypeList() {
      return this.$get(requestNbType()).then((res) => {
        const {
          status,
          data: { rows },
        } = res;
        if (status === 200) {
          this.nbTypeList = rows;
        }
      });
    },
  },

  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      parking: (state) => state.parking.oneParking,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.devManger_btn_edit = this.elements["devManger:btn_edit"];
      this.devManger_btn_remove = this.elements["devManger:btn_remove"];
      this.devManger_btn_add = this.elements["devManger:btn_add"];
    },
  },

  components: {
    Page,
    // StationTree,
    ExportExcel,
    Refresh,
    AreaTree,
    SearchParking,
  },
  created: function () {
    //this.getOrderType();
  },
  mounted: function () {
    this.permiss;
    //   this.tableList(this.search.pageNumber);
    // this.tableListAll();
    // this.tableListParkAll();
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
    // 'editOrAddForm.parkingId'(val){

    // 	  	this.tableListAreaAll(val);
    //   }
  },
};
</script>
  
  <style scoped>
/* @import "@/assets/css/equip.css"; */
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.btns {
  margin: 20px auto 0;
  width: 150px;
}

table td label {
  margin-bottom: 0 !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  border-radius: 1px;
}
.boxbgcolor {
  display: flex;
}
.battery {
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.electricity {
  display: flex;
  justify-content: center;
  align-items: center;
}
.downloadButton {
  font-weight: bold;
  color: #278cd8;
  cursor: pointer;
}
.list {
  padding: 0 !important;
}
.table thead {
  background: #f9f9fb;
}
.searchbox .el-input {
  width: 180px !important;
}
</style>
  